export const SITE_URL =
  import.meta.env.VITE_SITE_URL?.replace(/\/$/, '') || 'https://testlaunch.site'

export const PUBLIC_SOLANA_RPC = 'https://solana-rpc.publicnode.com'

export const RPC_ENDPOINT =
  import.meta.env.VITE_SOLANA_RPC || PUBLIC_SOLANA_RPC

/** Feature flag: when true, wallet + @pump-fun/pump-sdk create path is active. */
export const ENABLE_SDK_CREATE =
  (import.meta.env.VITE_ENABLE_SDK_CREATE ?? 'true').toLowerCase() !== 'false'

export const TOKEN = {
  name: 'EXFUND',
  symbol: 'EXFUND',
  description:
    'EXFUND routes a transparent percentage of trading fees into verified microgrants that help people move on after a breakup—moving deposits, rent bridges, counseling co-pays. The joke is the ticker; the commitment is the ledger. Not a registered charity. Meme coins are high risk; no guaranteed returns.',
  website: SITE_URL,
  metadataUri: `${SITE_URL}/metadata.json`,
  imageUri: `${SITE_URL}/logo.png`,
  logoPath: '/logo.png',
} as const

export const PUMP_CREATE_URL = 'https://pump.fun/create'

export const FEE_PERCENT = 15
